export const LoadingMaskWrap = () => {
	return (
		<div className="loader-wrapper ">
			<div className="loader"></div>
		</div>
	)
}
